/* Clarve — Therapy Finder
   Front-door quiz: details (up front) -> goal -> novice-answerable intake ->
   safety screeners -> the candidate peptide's R99 Dr Consult, with a full
   profile attached for the consult team.
   Question set + deterministic routing: plans/2026-06-10-therapy-finder-questions-final.md
   (5-agent panel, novice-proof — the customer never picks a product/format/"stack"/"DAC").
   Catalogue facts: reference/clarve-playbook/peptides/*. NO weight-loss peptides.
   Models: assets/clarve.js quiz block + sections/pdp-zv-eligibility.liquid cart.
*/
(function () {
  var stage = document.getElementById('tf-stage');
  if (!stage) return;

  var sectionEl = document.querySelector('[data-tf-section]');
  var ghlHook   = (sectionEl && sectionEl.getAttribute('data-tf-ghl')) || '';
  var ghlHookComplete = (sectionEl && sectionEl.getAttribute('data-tf-ghl-complete')) || '';
  var ghlHookCheckout = (sectionEl && sectionEl.getAttribute('data-tf-ghl-checkout')) || '';
  var introHead   = document.querySelector('.tf-head');
  var introSub    = document.querySelector('.tf-sub');
  var introKicker = document.querySelector('.tf-kicker-wrap');
  var introWrap   = document.querySelector('.tf-intro');
  // The top of the page repeats what the visitor just saw, so the ad and the quiz feel like one step
  // (Jandre 2026-09-22). Pain ads link with ?pain=..., site pages add ?from=... (theme.liquid).
  // b = quiz branch that gets picked for them, so they skip "what do you want help with?".
  var MATCH_PAIN = {
    injury:      { b: 'recovery', h: 'Still sore months after the injury?', e: 'Peptides may help your body repair it.' },
    rested:      { b: 'recovery', h: 'Rested it for weeks, and it still hurts?', e: 'Peptides may help your body repair it.' },
    training50:  { b: 'recovery', h: 'Still training, but injuries heal slower?', e: 'Peptides may help your body repair faster.' },
    recovery30s: { b: 'gh', h: 'Recovering slower than in your 30s?', e: 'Peptides may help your body make more of its own growth hormone.' },
    hgh:         { b: 'gh', h: 'Thinking about using HGH?', e: 'Peptides may help your body make more of its own growth hormone instead.' },
    skin:        { b: 'skin', h: 'Skin getting thinner and looser?', e: 'Peptides may help your skin make more collagen.' },
    creams:      { b: 'skin', h: 'Creams not changing your skin?', e: 'Peptides may help your skin make more collagen.' },
    sick:        { b: 'immune', h: 'Getting sick more often?', e: 'Peptides may help the cells that fight infection work better.' },
    rundown:     { b: 'immune', h: 'Still run down after being ill?', e: 'Peptides may help the cells that fight infection work better.' }
  };
  var MATCH_FROM = {
    'recovery-healing': { b: 'recovery', h: 'An injury or sore joints that won’t heal?', e: 'Peptides may help your body repair faster.' },
    'growth-hormone':   { b: 'gh', h: 'Your body makes less growth hormone as you age.', e: 'Peptides may help it make more of its own.' },
    'skin-beauty':      { b: 'skin', h: 'Skin getting thinner, looser or duller?', e: 'Peptides may help your skin make more collagen.' },
    'immune-longevity': { b: 'immune', h: 'Getting sick more often than you used to?', e: 'Peptides may help the cells that fight infection work better.' },
    'what-are-peptides':{ b: '', h: 'See if peptides may help you,', e: 'a registered doctor checks what suits you.' }
  };
  // Product pages (?from=<product handle>) name the peptide the visitor was just reading about (Jandre 2026-09-22).
  // Matched on the start of the handle, so the 10mg and 20mg pages share one line. Beats ?cat=, loses to ?pain=.
  // Glow uses its full handle: glow-stack-peptide-therapy (no -1) is the R99 consult product, not the Glow Stack.
  var MATCH_PRODUCT = [
    ['bpc-157',   { b: 'recovery', h: 'Still sore months after an injury?', e: 'See if BPC-157 may help your body repair it.' }],
    ['tb4',       { b: 'recovery', h: 'Stiff or sore in more than one place?', e: 'See if TB4 may help your body repair it.' }],
    ['wolverine', { b: 'recovery', h: 'An injury that still hurts months later?', e: 'See if the Wolverine Stack may help your body repair it.' }],
    ['ghk-cu',    { b: 'skin', h: 'Skin getting thinner, looser or duller?', e: 'See if GHK-Cu may help your skin make more collagen.' }],
    ['glow-stack-peptide-therapy-1', { b: 'skin', h: 'Skin getting thinner, looser or duller?', e: 'See if the Glow Stack may help your skin make more collagen.' }],
    ['cjc',       { b: 'gh', h: 'Your body makes less growth hormone as you age.', e: 'See if CJC + Ipamorelin may help it make more of its own.' }],
    ['ipamorelin',{ b: 'gh', h: 'Your body makes less growth hormone as you age.', e: 'See if Ipamorelin may help it make more of its own.' }],
    ['thymosin',  { b: 'immune', h: 'Getting sick more often than you used to?', e: 'See if Thymosin Alpha-1 may help the cells that fight infection work better.' }]
  ];
  function productMatch(from) {
    if (!from) return null;
    for (var i = 0; i < MATCH_PRODUCT.length; i++) if (from.indexOf(MATCH_PRODUCT[i][0]) === 0) return MATCH_PRODUCT[i][1];
    return null;
  }
  var qs0 = new URLSearchParams(window.location.search);
  // Articles send ?cat= (their category tag, added in theme.liquid) and get that category page's headline.
  var CAT_PAGE = { recovery: 'recovery-healing', 'growth-hormone': 'growth-hormone', skin: 'skin-beauty', immune: 'immune-longevity' };
  var match = MATCH_PAIN[qs0.get('pain')] || MATCH_FROM[qs0.get('from')] || productMatch(qs0.get('from')) || MATCH_FROM[CAT_PAGE[qs0.get('cat')]] || null;
  if (match && introHead) {
    introHead.innerHTML = match.h.replace(/&/g, '&amp;').replace(/</g, '&lt;') + ' <em>' + match.e + '</em>';
    if (introSub) introSub.hidden = true;  // the 3-step path below says it with fewer words
  }
  // One line under the headline instead of the 3-step picture path (Jandre 2026-09-23).
  var pathEl = document.createElement('div');
  pathEl.className = 'tf-pathbox';
  pathEl.innerHTML = '<p class="tf-path__head">Please answer a few questions before your doctor\u2019s consultation. It takes 60 seconds.</p>';
  if (introWrap) introWrap.appendChild(pathEl);
  var goalAsked = false;  // true once they chose to go back and pick another goal
  var introOrig   = { head: introHead ? introHead.innerHTML : '', sub: introSub ? introSub.innerHTML : '' };

  var progressFill  = document.getElementById('tf-progress-fill');
  var stepPill      = document.getElementById('tf-step-pill');
  var progressLabel = document.getElementById('tf-progress-label');

  var routes = {};
  try { routes = JSON.parse(document.getElementById('tf-routes').textContent); } catch (e) { routes = {}; }

  // Single consult product every completed quiz routes to. The matched therapy
  // is no longer a separate product; it is carried on the line-item properties
  // ("Likely fit") so the consult team still sees what the customer wanted.
  var PEPTIDE_DOCTOR_CONSULT = 53012179550502; // "Peptide Dr Consult", R99 (active)

  // ── Config ───────────────────────────────────────────────────────────────
  var TF = {
    goal: {
      key: 'goal',
      q: 'What are you hoping to get help with?',
      options: [
        { label: 'Recover from injury, pain, or improve gut comfort and digestion', branch: 'recovery' },
        { label: 'Better sleep, recovery, energy, or muscle as I get older',     branch: 'gh' },
        { label: 'Healthier skin or hair, or smoothing signs of ageing',          branch: 'skin' },
        { label: 'A stronger immune system, or bouncing back after being ill',    branch: 'immune' }
      ]
    },

    branches: {
      // Recovery — BPC-157 (one spot / gut), TB4 (several areas / general), Wolverine (severe)
      recovery: {
        questions: [
          { key: 'issue', q: "What best describes what you're dealing with?", options: [
            { label: 'Pain or injury in one specific spot (knee, shoulder, elbow, Achilles)', v: 'one_spot' },
            { label: 'Gut or digestion discomfort (bloating, slow gut recovery)',  v: 'gut' },
            { label: 'Aches, strains, or stiffness in several parts of my body',              v: 'multi_area' },
            { label: 'Recovering from surgery or a serious injury',                           v: 'severe' },
            { label: 'General wear and tear, I just want to recover and heal better overall', v: 'general' } ] },
          { key: 'severity', q: 'How much is it affecting your daily life or training?', options: [
            { label: 'A niggle, annoying but I push through',          v: 'low' },
            { label: 'It holds me back from training or daily things',  v: 'medium' },
            { label: "It's stopping me doing things I need or love to do", v: 'high' } ] },
          { key: 'duration', q: 'How long has this been going on?', options: [
            { label: 'Under 4 weeks (recent)', v: 'acute' },
            { label: '1 to 6 months',          v: 'subacute' },
            { label: 'Over 6 months (long-standing)', v: 'chronic' } ] }
        ],
        resolve: function (v) {
          if (v.issue === 'severe') return 'wolverine-stack';
          if (v.issue === 'gut')    return 'bpc-157';
          if (v.issue === 'one_spot') return v.severity === 'high' ? 'wolverine-stack' : 'bpc-157';
          if (v.issue === 'multi_area') return (v.severity === 'high' && v.duration === 'chronic') ? 'wolverine-stack' : 'tb-500';
          if (v.issue === 'general')    return (v.severity === 'high' && v.duration === 'chronic') ? 'wolverine-stack' : 'tb-500';
          return 'bpc-157';
        },
        screeners: []
      },

      // Growth hormone — Ipamorelin (gentle), Ipamorelin+CJC (fuller), CJC-DAC (fewest injections)
      gh: {
        questions: [
          { key: 'gh_goal', q: 'What matters most to you right now?', options: [
            { label: 'Sleeping better and recovering faster',      v: 'recovery' },
            { label: 'Feeling stronger and holding onto muscle',   v: 'muscle' },
            { label: 'More energy and feeling younger as I age',   v: 'vitality' } ] },
          { key: 'injection_pref', q: 'How do you feel about injections?', options: [
            { label: "I'd prefer as few injections as possible",   v: 'fewest' },
            { label: 'A regular small injection is completely fine', v: 'routine' } ] },
          { key: 'start_point', q: 'Where are you starting from?', options: [
            { label: 'New to this, I would like to ease in gently',            v: 'new' },
            { label: 'I look after myself and want a fuller, thorough approach', v: 'committed' } ] }
        ],
        resolve: function (v) {
          // cjc-dac + ipamorelin-cjc consults are DRAFT on the store, so route to the active Ipamorelin consult until they are published. The doctor confirms the exact GH combo at the consult anyway.
          return 'ipamorelin';
        },
        screeners: ['diabetes']
      },

      // Skin — GHK-Cu (one concern / hair / wound), Glow Stack (overall / several)
      skin: {
        questions: [
          { key: 'concern', q: 'What would you most like to improve?', options: [
            { label: 'Fine lines, firmness, or a specific area of my skin', v: 'lines' },
            { label: 'My overall skin quality and glow',                    v: 'glow' },
            { label: 'My hair (growth or thickness)',                       v: 'hair' },
            { label: 'Healing of a wound, scar, or mark',                   v: 'wound' } ] },
          { key: 'scope', q: 'Is this about one main thing, or your skin overall?', options: [
            { label: 'Mainly one thing I want to target',                   v: 'one' },
            { label: 'A few things, I want my skin looking its best all round', v: 'several' } ] }
        ],
        resolve: function (v) {
          if (v.concern === 'hair')  return 'ghk-cu';
          if (v.concern === 'wound') return 'ghk-cu';
          if (v.concern === 'glow')  return 'glow-stack';
          if (v.concern === 'lines') return v.scope === 'several' ? 'glow-stack' : 'ghk-cu';
          return 'ghk-cu';
        },
        screeners: ['bariatric', 'wilsons']
      },

      // Immune / longevity — Thymosin Alpha-1 (only product; questions build the profile)
      immune: {
        questions: [
          { key: 'immune_focus', q: 'What are you mainly hoping to support?', options: [
            { label: 'Catching fewer colds and bugs',                              v: 'resilience' },
            { label: 'Bouncing back after an illness (still run-down afterwards)',  v: 'post_viral' },
            { label: 'Feeling generally stronger and more resilient as I age',      v: 'longevity' } ] },
          { key: 'immune_history', q: 'How often do you find yourself run down or getting sick?', options: [
            { label: 'Often, more than I would like', v: 'often' },
            { label: 'Now and then',                   v: 'sometimes' },
            { label: 'Rarely',                         v: 'rarely' } ] }
        ],
        resolve: function () { return 'thymosin-alpha-1'; },
        screeners: ['autoimmune', 'immunosuppressant']
      }
    },

    // Cancer is soft-route everywhere (incl. Immune — Thymosin is studied as a cancer adjunct):
    // a red flag never blocks, it reroutes to "needs doctor review".
    universal: ['age', 'cancer', 'pregnancy'],

    screeners: {
      age:               { key: 'age',               q: 'Are you 18 years of age or older?', options: [ { label: 'Yes, 18 or older' }, { label: 'No, under 18', redFlag: true } ] },
      pregnancy:         { key: 'pregnancy',         q: 'Are you currently pregnant or breastfeeding?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' }, { label: 'Not applicable' } ] },
      cancer:            { key: 'cancer_history',    q: 'Have you been diagnosed with any form of cancer in the last 5 years?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' } ] },
      diabetes:          { key: 'diabetes',          q: 'Do you have type 1 or insulin-dependent diabetes?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' }, { label: 'I have type 2 managed without insulin' } ] },
      autoimmune:        { key: 'autoimmune',        q: 'Have you been diagnosed with an active autoimmune condition (lupus, MS, rheumatoid arthritis, Crohn’s, etc.)?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' } ] },
      immunosuppressant: { key: 'immunosuppressant', q: 'Are you currently taking immunosuppressive medication (e.g. for transplant, autoimmune disease, or chemotherapy)?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' } ] },
      bariatric:         { key: 'bariatric',         q: 'Have you had bariatric (weight-loss) surgery, such as gastric bypass or sleeve?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' } ] },
      wilsons:           { key: 'wilsons',           q: 'Have you ever been diagnosed with Wilson’s disease, copper sensitivity, or a copper allergy?', options: [ { label: 'Yes', redFlag: true }, { label: 'No' } ] }
    }
  };

  var goalLabel = {
    recovery: 'Recovery and healing', gh: 'Growth hormone and ageing',
    skin: 'Skin, hair and glow', immune: 'Immune and longevity'
  };

  // ── State ────────────────────────────────────────────────────────────────
  var answers, vals, chosen, flags, needsReview, chosenRoute, branchKey, queue, qIndex, screen;
  var started = false;  // details already sent this visit (set after the quiz-start reload)

  function reset() {
    answers = {}; vals = {}; chosen = {}; flags = []; needsReview = false;
    chosenRoute = null; branchKey = null; queue = []; qIndex = 0; screen = null;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function setProgress(done, total, label) {
    if (progressFill) progressFill.style.width = (total ? Math.min((done / total) * 100, 100) : 0) + '%';
    if (progressLabel) progressLabel.textContent = label;
  }

  // Phones: the details form is long, so after an answer people were left looking at the footer
  // with the next question above them (Clarity, 2026-09-17). Bring the question back into view.
  function toStage() {
    var top = stage.getBoundingClientRect().top;
    if (top >= 70 && top < window.innerHeight / 2) return;
    var y = top + window.pageYOffset - 90;
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
  }

  // Leaving the result (Back, then return) showed the start screen, so they had to redo the quiz
  // (Clarity, 2026-09-17). The finished quiz is kept on this device for a day; Start again clears it.
  var SAVE_KEY = 'clarve_tf_result', SAVE_MS = 24 * 60 * 60 * 1000;
  function saveResult() {
    try { localStorage.setItem(SAVE_KEY, JSON.stringify({ t: Date.now(), answers: answers, vals: vals, chosen: chosen, branchKey: branchKey })); } catch (e) {}
  }
  function loadResultOk() {
    try { return !!localStorage.getItem(SAVE_KEY); } catch (e) { return false; }
  }
  function clearResult() {
    try { localStorage.removeItem(SAVE_KEY); } catch (e) {}
  }
  function loadResult() {
    try {
      var d = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null');
      if (!d || Date.now() - d.t > SAVE_MS || !TF.branches[d.branchKey]) return false;
      answers = d.answers || {}; vals = d.vals || {}; chosen = d.chosen || {}; branchKey = d.branchKey;
      buildQueue(branchKey);
      return true;
    } catch (e) { return false; }
  }

  // Meta custom conversions match on the page address ("quiz-start", "quiz-finished"). The Facebook app's
  // tag only sends a PageView on a real page load, so the quiz reloads itself with that word in the
  // address after the details step and after the spinner (Jandre 2026-09-21). The lead is sent to GHL
  // (keepalive) and saved on this device first, so the reload loses nothing.
  var DETAILS_KEY = 'clarve_tf_details';
  function saveDetails() {
    try {
      localStorage.setItem(DETAILS_KEY, JSON.stringify({ t: Date.now(), name: answers.name, email: answers.email, phone: answers.phone }));
      return !!localStorage.getItem(DETAILS_KEY);
    } catch (e) { return false; }
  }
  function loadDetails() {
    try {
      var d = JSON.parse(localStorage.getItem(DETAILS_KEY) || 'null');
      if (!d || Date.now() - d.t > SAVE_MS || !d.email) return false;
      answers.name = d.name || ''; answers.email = d.email; answers.phone = d.phone || '';
      return true;
    } catch (e) { return false; }
  }
  function clearDetails() {
    try { localStorage.removeItem(DETAILS_KEY); } catch (e) {}
  }
  function reloadAs(word) {
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('quiz', word);
      window.location.replace(u.toString());
      return true;
    } catch (e) { return false; }
  }
  // Meta credited ad clicks with "quiz-start" but almost never with "quiz-finished", although it received both
  // (22 Sep 2026: 16 starts vs 0 click-credited finishes, 17 real finishers in GHL). Both were page views, so
  // the finish now also goes as its own named event, "QuizFinished", from this page (not Shopify's sandbox),
  // so the ad click id in the address and cookies travels with it. No PageView is sent from here.
  var META_PIXEL = '1920467608911685';
  function metaQuizFinished() {
    try {
      if (!window.fbq) {
        var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!window._fbq) window._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        var t = document.createElement('script'); t.async = true; t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(t);
      }
      window.fbq.disablePushState = true;  // cleanAddress() changes the address; that must not send extra page views
      window.fbq('set', 'autoConfig', false, META_PIXEL);
      window.fbq('init', META_PIXEL);
      window.fbq('trackSingleCustom', META_PIXEL, 'QuizFinished', { goal: goalLabel[branchKey] || '', therapy: chosenRoute || '' });
    } catch (e) {}
  }

  // Take the word out again once Meta has counted the page, so a refresh doesn't count twice.
  function cleanAddress(delay) {
    if (!param('quiz')) return;
    var go = function () { setTimeout(function () {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('quiz');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }, delay); };
    // Counted from full load: slow phones publish the page view late.
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
  }

  // Step 1 = the questions, step 2 = pay R99 (result screen).
  function setStep(n) {
    if (stepPill) stepPill.textContent = 'Step ' + n + ' of 3';
  }
  // The result has nothing to count, so the step row and the bar come off there (Jandre 2026-09-23).
  function showCardTop(on) {
    var t = document.querySelector('.tfx-top'), b = document.querySelector('.quiz-progress-wrap');
    if (t) t.hidden = !on;
    if (b) b.hidden = !on;
  }

  var hint = '<p class="tfx-hint">Tap the answer that fits you best.</p>';

  function backBtn() { return '<button type="button" class="tf-back" data-tf-back>&larr; Back</button>'; }
  function wireBack() {
    var b = stage.querySelector('[data-tf-back]');
    if (b) b.addEventListener('click', back);
  }

  // ── GoHighLevel push (name + email + phone -> contact + pipeline) ─────────
  // Sent once, on the Start click, because that is the first moment we hold a
  // phone number. Must be application/json: GoHighLevel returns 200 for a
  // text/plain body but silently drops it (verified 2026-09-11). Its webhook
  // answers the CORS preflight with allow-origin *, so JSON from the browser works.
  function normalisePhone(raw) {
    var t = String(raw == null ? '' : raw).trim();
    var hasPlus = t.charAt(0) === '+';
    var d = t.replace(/\D/g, '');
    if (!d) return '';
    if (hasPlus) return '+' + d;
    if (d.indexOf('27') === 0 && d.length > 10) return '+' + d;
    if (d.charAt(0) === '0') return '+27' + d.slice(1);
    return '+27' + d;
  }

  function param(k) {
    try { return new URLSearchParams(window.location.search).get(k) || ''; } catch (e) { return ''; }
  }

  function savedSource() {
    try { return JSON.parse(localStorage.getItem('clarve_src') || '{}') || {}; } catch (e) { return {}; }
  }

  function pushToGhl(url, extra) {
    if (!url) return;
    var full  = (answers.name || '').trim();
    var first = full.split(' ')[0];
    var last  = full.split(' ').slice(1).join(' ');
    var payload = {
      first_name: first,
      last_name:  last,
      full_name:  full,
      name:       full,
      email:      answers.email || '',
      phone:      normalisePhone(answers.phone),
      source:     'Clarve Therapy Finder',
      page_url:   window.location.href,
      referrer:   document.referrer || '',
      utm_source:   param('utm_source'),
      utm_medium:   param('utm_medium'),
      utm_campaign: param('utm_campaign'),
      utm_content:  param('utm_content'),
      utm_term:     param('utm_term'),
      fbclid:       param('fbclid'),
      // Set by the link tagger in layout/theme.liquid; GHL saves it as a contact tag for the per-page dashboard
      from_tag:     'from-' + (param('from') || 'direct'),
      // Saved on landing by the source script in layout/theme.liquid (utm links drop off once they click into the quiz)
      from_page:    ({ homepage: 'Homepage', 'recovery-healing': 'Recovery + Healing', 'growth-hormone': 'Growth Hormone',
                      'immune-longevity': 'Immune + Longevity', 'skin-beauty': 'Skin + Beauty', all: 'All Therapies',
                      popup: 'Pop-up', 'guide-email': 'Guide emails' })[param('from')]
                    || (param('from') ? param('from') : 'Went straight to the quiz'),
      traffic_source: savedSource().source || 'Direct',
      ad_campaign:    savedSource().campaign || '',
      ad_name:        savedSource().ad || ''
    };
    Object.keys(extra || {}).forEach(function (k) { payload[k] = extra[k]; });
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  // ── Lead capture (Shopify customer, on the details step) ──────────────────
  function captureLead() {
    var form = document.getElementById('tf-hidden-form');
    var fd;
    if (form) {
      document.getElementById('tf-hidden-email').value = answers.email || '';
      document.getElementById('tf-hidden-first').value = (answers.name || '').split(' ')[0];
      document.getElementById('tf-hidden-last').value  = (answers.name || '').split(' ').slice(1).join(' ');
      fd = new FormData(form);
    } else {
      fd = new FormData();
      fd.append('form_type', 'newsletter'); fd.append('utf8', '✓');
      fd.append('email', answers.email || '');
      fd.append('contact[first_name]', (answers.name || '').split(' ')[0]);
    }
    fetch('/contact', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd, keepalive: true }).catch(function () {});
  }

  // ── Step A: details first ─────────────────────────────────────────────────
  // Back to first on 2026-09-21: with details last (18-20 Sep) people quit mid-quiz and left no lead at all.
  function renderGate(noScroll) {
    screen = 'gate';
    setStep(1);
    setProgress(0, 0, 'Your details');
    var nm = answers.name || '', em = answers.email || '', ph = answers.phone || '';
    // Asked for the guide in the pop-up (snippets/clarve-popup.liquid)? Their name + email wait here, so they only add their number.
    if (!nm && !em) {
      try {
        var g = JSON.parse(localStorage.getItem('clarve_guide_lead') || 'null');
        if (g && Date.now() - g.t < 30 * 864e5) { nm = g.name || ''; em = g.email || ''; }
      } catch (e) {}
    }
    stage.innerHTML =
      '<div class="quiz-q-text">Add your details, so your doctor can see your answers.</div>' +
      '<p class="tfx-hint">The questions start straight after.</p>' +
      '<div class="quiz-gate-form">' +
        '<div class="quiz-field"><label class="quiz-field-label" for="tf-name">Your name</label>' +
          '<input type="text" class="quiz-field-input" id="tf-name" placeholder="First name" autocomplete="given-name" value="' + escapeHtml(nm) + '"></div>' +
        '<div class="quiz-field"><label class="quiz-field-label" for="tf-email">Email address</label>' +
          '<input type="email" class="quiz-field-input" id="tf-email" placeholder="your@email.com" autocomplete="email" value="' + escapeHtml(em) + '"></div>' +
        '<div class="quiz-field"><label class="quiz-field-label" for="tf-phone">Contact number</label>' +
          '<input type="tel" class="quiz-field-input" id="tf-phone" placeholder="082 000 0000" autocomplete="tel" value="' + escapeHtml(ph) + '"></div>' +
        '<div class="quiz-field-error" id="tf-gate-error"></div>' +
        '<button class="btn-primary" id="tf-gate-submit" style="width:100%;margin-top:8px;">Continue To The Questions &rarr;</button>' +
        '<div class="quiz-gate-note">We use these details so a doctor can contact you and to email you about your consultation. Your details are protected under South African privacy law.</div>' +
      '</div>';

    var errorEl = document.getElementById('tf-gate-error');
    var emailEl = document.getElementById('tf-email');

    emailEl.addEventListener('blur', function () {
      var e = (emailEl.value || '').trim();
      if (e && e.indexOf('@') > -1) { answers.email = e; answers.name = (document.getElementById('tf-name').value || '').trim(); captureLead(); }
    });

    function submit() {
      var name  = (document.getElementById('tf-name').value  || '').trim();
      var email = (emailEl.value || '').trim();
      var phone = (document.getElementById('tf-phone').value || '').trim();
      errorEl.textContent = '';
      if (!name)  { errorEl.textContent = 'Please enter your name.'; return; }
      if (!email || email.indexOf('@') < 0) { errorEl.textContent = 'Please enter a valid email address.'; return; }
      if (!phone) { errorEl.textContent = 'Please enter a contact number.'; return; }
      answers.name = name; answers.email = email; answers.phone = phone;
      captureLead();
      pushToGhl(ghlHook, { event: 'quiz_started' });
      // Only the first submit reloads; Back to the details and Continue again just moves on.
      if (!started && saveDetails() && reloadAs('quiz-start')) return;
      renderGoal();
    }

    document.getElementById('tf-gate-submit').addEventListener('click', submit);
    ['tf-name', 'tf-email', 'tf-phone'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
    });
    if (!noScroll) toStage();
  }

  // ── Step B: goal ──────────────────────────────────────────────────────────
  function renderGoal(noScroll) {
    // Came from a matched ad or page: pick that goal for them and go straight to its first question.
    if (match && match.b && !goalAsked) {
      var pre = TF.goal.options.filter(function (o) { return o.branch === match.b; })[0];
      if (pre) { answers.goal = pre.label; branchKey = pre.branch; buildQueue(pre.branch); return renderQuestion(0); }
    }
    screen = 'goal';
    setStep(1);
    // Path lengths differ (7 or 8), so no total until the goal is picked.
    setProgress(0, 0, 'Question 1');
    var html = backBtn() + '<div class="quiz-q-text">' + escapeHtml(TF.goal.q) + '</div>' + hint + '<div class="quiz-answers">';
    TF.goal.options.forEach(function (o, i) {
      html += '<button class="quiz-answer-btn" data-i="' + i + '">' + escapeHtml(o.label) + '</button>';
    });
    html += '</div>';
    stage.innerHTML = html;
    wireBack();
    stage.querySelectorAll('.quiz-answer-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var o = TF.goal.options[+this.dataset.i];
        answers.goal = o.label; branchKey = o.branch;
        buildQueue(o.branch);
        renderQuestion(0);
      });
    });
    if (!noScroll) toStage();
  }

  // ── Step C+D: branch questions then screeners ─────────────────────────────
  function buildQueue(bKey) {
    var b = TF.branches[bKey];
    queue = b.questions.slice();
    TF.universal.forEach(function (k) { queue.push(TF.screeners[k]); });
    b.screeners.forEach(function (k) { queue.push(TF.screeners[k]); });
  }

  function renderQuestion(idx) {
    if (idx >= queue.length) return showWorking();
    screen = idx; qIndex = idx;
    var q = queue[idx];
    var skip = (match && match.b && !goalAsked) ? 1 : 0;  // goal question was answered for them
    setProgress(idx + 1, queue.length + 1, 'Question ' + (idx + 2 - skip) + ' of ' + (queue.length + 1 - skip));
    var html = backBtn() + '<div class="quiz-q-text">' + escapeHtml(q.q) + '</div>' + hint + '<div class="quiz-answers">';
    q.options.forEach(function (o, i) {
      html += '<button class="quiz-answer-btn" data-i="' + i + '">' + escapeHtml(o.label) + '</button>';
    });
    html += '</div>';
    stage.innerHTML = html;
    wireBack();
    stage.querySelectorAll('.quiz-answer-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var o = q.options[+this.dataset.i];
        answers[q.key] = o.label;
        vals[q.key] = (o.v != null) ? o.v : o.label;
        chosen[q.key] = o;
        renderQuestion(idx + 1);
      });
    });
    toStage();
  }

  // ── Back navigation ───────────────────────────────────────────────────────
  function back() {
    if (screen === 'goal') return renderGate();
    if (screen === 0)      { goalAsked = true; return renderGoal(); }
    if (typeof screen === 'number') return renderQuestion(screen - 1);
    renderGate();
  }

  // ── Derive flags from chosen (recomputed, so back-nav stays consistent) ───
  function computeFlags() {
    flags = []; needsReview = false;
    queue.forEach(function (item) {
      var ch = chosen[item.key];
      if (ch && ch.redFlag) { needsReview = true; flags.push(item.q.replace(/\?$/, '') + ' → ' + ch.label); }
    });
  }

  function buildIssues() {
    var parts = [ goalLabel[branchKey] || answers.goal ];
    (TF.branches[branchKey] ? TF.branches[branchKey].questions : []).forEach(function (q) {
      if (answers[q.key]) parts.push(answers[q.key]);
    });
    return parts.join(' · ');
  }

  // Readable note for the sales team in GHL: match first, then every question
  // with its answer, so nobody has to decode the " · " summary.
  function buildNote(route) {
    var lines = [
      'Therapy Finder result',
      'Matched therapy: ' + (route.title || 'None') + (needsReview ? ' (pending doctor review)' : ''),
      'Health warnings: ' + (flags.length ? flags.join('; ') : 'None'),
      '',
      TF.goal.q,
      '→ ' + (answers.goal || '')
    ];
    queue.forEach(function (q) {
      if (answers[q.key]) lines.push('', q.q, '→ ' + answers[q.key]);
    });
    return lines.join('\n');
  }

  // ── Result + cart ─────────────────────────────────────────────────────────
  // Result screen swaps the page headline to a finished state, so nobody thinks
  // another question is coming. restoreIntro() puts the start copy back on "Start again".
  function showDoneIntro(name) {
    // Wednesday 16 Sep wording (3 consults paid that day), back with the locked card (Jandre 2026-09-22).
    if (introHead) introHead.innerHTML = escapeHtml(name ? 'You\u2019re done, ' + name + '.' : 'You\u2019re done.') + '<br><em>A doctor now needs to review your answers.</em>';
    if (introSub) introSub.hidden = true;
    pathEl.hidden = true;
    if (introWrap) introWrap.classList.add('is-done');
    if (introKicker) introKicker.hidden = true;
  }

  function restoreIntro() {
    if (introHead) introHead.innerHTML = introOrig.head;
    if (introSub) { introSub.innerHTML = introOrig.sub; introSub.hidden = !!match; }
    pathEl.hidden = false;
    if (introWrap) introWrap.classList.remove('is-done');
    if (introKicker) introKicker.hidden = false;
    var topPay = document.getElementById('tf-top-pay');
    if (topPay) topPay.hidden = true;
    var revs = document.getElementById('tf-reviews');
    if (revs) revs.hidden = true;
    var nextHead = document.getElementById('tf-next-head');
    if (nextHead) nextHead.hidden = true;
    showCardTop(true);
  }

  // ~2s "working" screen before the result, so people see their answers went somewhere (Jandre 2026-09-18:
  // the result appeared so fast nothing seemed to change).
  function showWorking() {
    screen = 'working';
    setProgress(1, 1, 'Almost done');
    stage.innerHTML =
      '<div class="tfx-working" role="status" aria-live="polite">' +
        '<span class="tfx-spin" aria-hidden="true"></span>' +
        '<p class="tfx-working-line" id="tfx-working-line">Checking your answers...</p>' +
      '</div>';
    toStage();
    setTimeout(function () {
      var line = document.getElementById('tfx-working-line');
      if (line) line.textContent = 'Getting them ready for your doctor...';
    }, 1100);
    setTimeout(function () { showResult(); }, 2300);
  }

  // Call-today line (Jandre 2026-09-23): doctors phone Mon-Fri 8:30am to 4pm, never on weekends or SA public holidays,
  // so paying by 3:30pm SA time on a calling day = a call today. Always SA time, whatever the visitor's phone clock says.
  // Public holidays (Sunday ones already moved to the Monday). Add the next year's list before 2028.
  var SA_HOLIDAYS = ' 2026-01-01 2026-03-21 2026-04-03 2026-04-06 2026-04-27 2026-05-01 2026-06-16 2026-08-10 2026-09-24 2026-12-16 2026-12-25 2026-12-26' +
    ' 2027-01-01 2027-03-22 2027-03-26 2027-03-29 2027-04-27 2027-05-01 2027-06-16 2027-08-09 2027-09-24 2027-12-16 2027-12-25 2027-12-27 ';
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function isCallDay(d) {
    var wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && SA_HOLIDAYS.indexOf(' ' + d.toISOString().slice(0, 10) + ' ') < 0;
  }
  function callTiming() {
    var p = {};
    try {
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) { return null; }
    var today = new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), mins = (+p.hour % 24) * 60 + (+p.minute);
    // The next calling day after today, in the words a person would use.
    var next = new Date(today.getTime()), gap = 0;
    do { next.setUTCDate(next.getUTCDate() + 1); gap++; } while (!isCallDay(next) && gap < 14);
    var when = gap === 1 ? 'tomorrow' : 'on ' + DAY_NAMES[next.getUTCDay()];
    var hours = 'Doctors phone Monday to Friday, 8:30am to 4pm.';
    if (isCallDay(today) && mins < 8 * 60 + 30) return {
      today: false,
      label: 'Doctors start phoning at 8:30am',
      head: 'Pay now and a doctor phones you today, from 8:30am.',
      sub: hours,
      step: 'Today, from 8:30am, when the doctors start phoning.'
    };
    if (isCallDay(today) && mins < 15 * 60 + 30) return {
      today: true,
      head: 'Pay before 3:30pm and a doctor phones you today.',
      step: 'Today, usually within 30 minutes of paying.'
    };
    var holiday = SA_HOLIDAYS.indexOf(' ' + today.toISOString().slice(0, 10) + ' ') > -1;
    return {
      today: false,
      label: holiday ? 'Doctors are off for the public holiday' : 'Doctors are off for today',
      head: 'Pay now and a doctor phones you ' + when + ', from 8:30am.',
      sub: hours,
      step: 'Doctors phone Monday to Friday, 8:30am to 4pm, so yours phones you ' + when + '.'
    };
  }
  function renderCallTiming() {
    var t = callTiming(), box = document.getElementById('tf-calltime');
    if (!t) return;
    var step = document.querySelector('.tf-timeline li:first-child span');
    if (step) step.textContent = t.step;
    if (!box) return;
    if (!t.today) {
      box.className = 'tf-calltime tf-calltime--off';
      box.innerHTML = '<div class="tf-ct-top"><span class="tf-ct-on"><span class="tf-ct-dot"></span>' + t.label + '</span></div>' +
        '<p class="tf-ct-main">' + t.head.replace(/(today|tomorrow|on \w+day)/, '<strong>$1</strong>') + '</p>' +
        '<p class="tf-ct-note">' + t.sub + '</p>';
      return;
    }
    // Seconds to the 3:30pm cut-off, in SA time.
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Johannesburg', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var left = Math.max(0, 55800 - ((+p.hour % 24) * 3600 + (+p.minute) * 60 + (+p.second)));
    var hh = Math.floor(left / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var clk = '<svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></g></svg>';
    box.className = 'tf-calltime';
    box.innerHTML = '<div class="tf-ct-top"><span class="tf-ct-on"><span class="tf-ct-dot"></span>Doctors are available now</span>' +
        '<span class="tf-ct-left">' + clk + (hh ? hh + 'h ' : '') + pad(mm) + 'm ' + pad(ss) + 's left</span></div>' +
      '<p class="tf-ct-main">Pay before <strong>3:30pm</strong> and a doctor phones you <strong>today</strong>.</p>' +
      // Bar = how much of the calling day (8:30am to 3:30pm) has gone.
      '<div class="tf-ct-bar"><span style="width:' + Math.max(3, Math.min(100, 100 - left / 252)) + '%"></span></div>';
  }


  // restored = shown again from the saved copy, so GHL isn't told twice.
  function showResult(restored) {
    screen = 'result';
    showCardTop(false);
    // The floating CX WhatsApp button covered the pay button on phones (Clarity, 2026-09-17).
    document.documentElement.classList.add('tf-on-result');
    setStep(2);
    computeFlags();
    chosenRoute = TF.branches[branchKey].resolve(vals);
    var route = routes[chosenRoute] || {};
    var name  = (answers.name || '').split(' ')[0];

    // Result screen = quiz completed: GHL moves the lead to "Quiz Completed" and
    // the phone team gets the match + answers. Fires here (not on the checkout
    // click) so people who see their result but never click through still move.
    if (!restored) saveResult();
    var reload = !restored && loadResultOk();
    if (!restored) pushToGhl(ghlHookComplete, {
      event:        'quiz_completed',
      goal:         goalLabel[branchKey] || answers.goal || '',
      likely_fit:   (needsReview ? '(pending doctor review) ' : '') + (route.title || ''),
      needs_review: needsReview ? 'yes' : 'no',
      flags:        flags.length ? flags.join('; ') : 'None',
      quiz_summary: buildIssues(),
      therapy_tag:  chosenRoute ? 'quiz-' + chosenRoute : '',
      quiz_note:    buildNote(route)
    });
    // The reloaded page shows this result from the saved copy (restored), so GHL isn't told twice.
    if (reload && reloadAs('quiz-finished')) return;

    setProgress(1, 1, 'Done ✓');
    showDoneIntro(name);
    // No locked match on the page (Jandre 2026-09-18: a padlock after "have a doctor call me" felt like a trick).
    // The screen says what happens after the R99 instead. GHL still gets the match for the sales team.
    var told = [answers.goal];
    (TF.branches[branchKey] ? TF.branches[branchKey].questions : []).forEach(function (q) {
      if (answers[q.key]) told.push(answers[q.key]);
    });

    var waSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#25D366" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.3-.5.1-1 .1-1.7-.1a15 15 0 0 1-6.1-5.4c-.5-.7-1-1.8-1-2.8 0-1 .5-1.5.7-1.7.2-.2.4-.3.6-.3h.4c.1 0 .3 0 .5.4l.7 1.7c.1.2.1.3 0 .5l-.3.4-.3.4c-.1.1-.2.3 0 .5.2.3.7 1.1 1.4 1.7.9.8 1.7 1.1 2 1.2.2.1.4.1.5-.1l.7-.9c.2-.2.3-.2.5-.1l1.6.8c.2.1.4.2.4.3.1.1.1.6-.1 1.2z"/></svg>';
    var askSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="#8a6d2f" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.5"/><path d="M9.2 9.3a2.9 2.9 0 0 1 5.6 1c0 1.9-2.8 2.5-2.8 4"/><path d="M12 17.6h.01"/></g></svg>';

    stage.innerHTML =
      // Two parts and a picture per step: leads did not know what the call covers or what happens after it (Jandre, 12 Oct 2026)
      '<p class="tf-phase">First: your once-off R99 doctor call</p>' +
      '<ol class="tf-steps tf-timeline tf-icons">' +
        '<li><i class="tf-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="#111315" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6.6 3h3l1.5 4-2 1.5a12 12 0 0 0 5.4 5.4l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4.6 5a2 2 0 0 1 2-2z"/></g></svg></i><strong>A registered doctor phones you</strong><span>Usually within 30 minutes of paying.</span></li>' +
        '<li><i class="tf-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="#111315" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="4.5" width="14" height="16.5" rx="2"/><path d="M9 3h6v3.5H9z"/><path d="M9 13.5l2.2 2.2 4-4.2"/></g></svg></i><strong>They check if peptide therapy is safe for you</strong><span>Your answers from this quiz go straight to them.</span>' +
          '<div class="tf-asks"><b>On the call, the doctor asks you:</b>' +
            '<div class="tf-ask">What you want help with</div>' +
            '<div class="tf-ask">Your age, weight and height</div>' +
            '<div class="tf-ask">If you have any illness or allergies</div>' +
            '<div class="tf-ask">If you smoke, drink, or see another doctor</div>' +
            '<p>Then the doctor explains which therapy could suit you and what to expect from it. You can ask the doctor anything.</p>' +
          '</div></li>' +
        '<li><i class="tf-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="#111315" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4"/><path d="M10 12h5M10 16h5"/></g></svg></i><strong>If a therapy suits you, they prescribe it</strong><span>The prescription goes straight to our pharmacy, and the doctor tells you the price.</span></li>' +
      '</ol>' +
      '<p class="tf-phase">After the call: only if you want to go ahead</p>' +
      '<ol class="tf-steps tf-timeline tf-icons tf-timeline--after">' +
        '<li><i class="tf-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="#111315" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18M7 14.5h4"/></g></svg></i><strong>We send you a link to pay for your therapy</strong><span>About 30 minutes after the call. The link never expires, so you can decide in your own time.</span></li>' +
        '<li><i class="tf-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><g fill="none" stroke="#111315" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l9-5 9 5v8l-9 5-9-5z"/><path d="M3 8l9 5 9-5M12 13v8"/></g></svg></i><strong>Our pharmacy makes it and delivers it to your door</strong><span>A courier keeps it cold all the way. It takes about 48 hours once it is sent.</span></li>' +
      '</ol>' +
      '<button class="btn-primary tf-done-cta tf-cta2">Secure My Once-Off R99 Doctor Consult &rarr;</button>' +
      '<p class="tf-restart-line">Want to change an answer? <button type="button" class="tf-restart">Start again</button></p>';

    // Pay + question buttons sit right under the headline, above the card, so they show without scrolling
    // (Jandre 2026-09-22: 0 of 4 leads reached checkout when the pay button sat below the fold).
    var topPay = document.getElementById('tf-top-pay');
    if (!topPay && introWrap) { topPay = document.createElement('div'); topPay.id = 'tf-top-pay'; introWrap.parentNode.insertBefore(topPay, introWrap.nextSibling); }
    if (topPay) {
      topPay.hidden = false;
      // Locked match card (was live up to 18 Sep, when 3 people paid on 16 Sep; back on Jandre's call 2026-09-22):
      // their match exists and has their name on it, the doctor call opens it. Never shows the therapy itself.
      var lockSvg = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#111315" d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 0 1 6 0v3H9z"/></svg>';
      topPay.innerHTML = '<div class="tf-seal' + (needsReview ? ' tf-seal--review' : '') + '">' +
          '<div class="tf-seal-top"><span>' + (needsReview ? 'Waiting for doctor review' : 'Your therapy match') + '</span><span>Prepared for ' + escapeHtml(name || 'you') + '</span></div>' +
          '<div class="tf-seal-body">' +
            (needsReview ? '' : '<div class="tf-seal-bars" aria-hidden="true"><span></span><span></span><span></span><span></span></div>') +
            '<div class="tf-seal-lock"><span class="tf-seal-icon">' + lockSvg + '</span>' +
              '<p class="tf-seal-status">' + (needsReview ? 'Some of your answers mean a doctor needs to talk to you before recommending any therapy.' : 'Locked until you consult with the doctor on a call') + '</p></div>' +
          '</div>' +
          '<p class="tf-seal-why">Peptides are prescription medicine, so only a doctor can decide which one is right for you.</p>' +
        '</div>' +
        '<div id="tf-calltime" class="tf-calltime"></div>' +
        '<button class="btn-primary tf-done-cta" id="tf-add">Secure My Once-Off R99 Doctor Consult &rarr;</button>' +
        '<button type="button" class="btn-ghost tf-wa" id="tf-wa">' + askSvg + '<span>I Have A Question</span></button>';
      renderCallTiming();
      // Ticks the countdown and flips to the after-hours words at 3:30pm while the page stays open.
      if (!window.__tfCallTimer) window.__tfCallTimer = setInterval(renderCallTiming, 1000);
      var addBtn = document.getElementById('tf-add');
      addBtn.addEventListener('click', function () { addToCart(route, addBtn); });
      // The same pay button lower down: under the 3 steps, and under the reviews (Jandre 2026-09-23).
      stage.querySelectorAll('.tf-cta2').forEach(function (b) {
        b.addEventListener('click', function () { addToCart(route, b); });
      });
      // Big heading above the card, in the same style as the reviews heading (Jandre 2026-09-23).
      var card = document.querySelector('.quiz-card');
      var nextHead = document.getElementById('tf-next-head');
      if (!nextHead && card) {
        nextHead = document.createElement('div'); nextHead.id = 'tf-next-head';
        nextHead.innerHTML = '<h2 class="rec-title">Here\u2019s what happens next</h2>';
        card.parentNode.insertBefore(nextHead, card);
      }
      if (nextHead) nextHead.hidden = false;
      var revs = document.getElementById('tf-reviews');
      if (revs) {
        revs.hidden = false;
        if (!revs.querySelector('.tf-rev-cta')) {
          var wrap = document.createElement('div'); wrap.className = 'tf-rev-cta';
          wrap.innerHTML = '<button class="btn-primary tf-done-cta tf-cta2">Secure My Once-Off R99 Doctor Consult &rarr;</button>';
          revs.appendChild(wrap);
        }
        revs.querySelectorAll('.tf-cta2').forEach(function (b) {
          if (b.dataset.wired) return; b.dataset.wired = '1';
          b.addEventListener('click', function () { addToCart(route, b); });
        });
      }
    }
    // Clarity event so we can see if the WhatsApp option helps or eats into R99 payments.
    // "I Have A Question" opens the site chat and tells it what they already answered, so it doesn't start over
    // (Jandre 2026-09-22: people tapped WhatsApp and waited). No chat on the page? Fall back to WhatsApp.
    document.getElementById('tf-wa').addEventListener('click', function () {
      if (typeof window.clarity === 'function') window.clarity('event', 'quiz_question_click');
      var context = 'Note, not from the visitor: they just finished the 60-second quiz on the quiz page and saw their result. Their answers: ' + told.join('; ') +
        '. The quiz matched a therapy, but only the doctor can choose it, so never name one. The page told them the consult costs a once-off R99, and that a registered doctor phones within 30 minutes of paying (doctors phone Monday to Friday, 8:30am to 4pm, never on weekends or public holidays, so paying by 3:30pm SA time on a working day means a call today, later means the next working day), checks their health and answers, and prescribes only if a therapy suits them, with the price given first. Do not ask their goal again and never start the doctor questions again. Answer every question fully and plainly, including what happens on the call, instead of saying the doctor will cover it. Only when they say they are ready, tell them to close this chat and tap the red Secure My Once-Off R99 Doctor Consult button.';
      if (typeof window.ClarveChatAsk === 'function') return window.ClarveChatAsk(context);
      window.open('https://wa.me/27616524356?text=' + encodeURIComponent('Hi Clarve, ' + (name ? 'this is ' + name + '. ' : '') + 'I just did the therapy quiz and have a question before I book my R99 consult.'), '_blank');
    });
    stage.querySelector('.tf-restart').addEventListener('click', function () { document.documentElement.classList.remove('tf-on-result'); clearResult(); clearDetails(); started = false; restoreIntro(); reset(); renderGate(); });
    // On phones the card sits below the fold; bring "You're done" into view.
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  }

  // ── Cart add → straight to checkout ───────────────────────────────────────
  // Every completed quiz adds the single Peptide Dr Consult, with the full quiz
  // profile on the line-item properties. The cart is cleared first so checkout
  // is exactly the R99 consult, then we skip the cart and go to /checkout.
  function addToCart(route, btn) {
    btn.disabled = true; btn.textContent = 'Adding…';
    // Moves the lead to "Opened Checkout". Shopify only records an abandoned checkout once an
    // email is typed, so this click is the only proof they reached checkout. keepalive lets it
    // finish after the redirect below.
    pushToGhl(ghlHookCheckout, { event: 'checkout_clicked', likely_fit: (needsReview ? '(pending doctor review) ' : '') + (route.title || '') });

    var properties = {
      'Issues':     buildIssues(),
      'Likely fit': (needsReview ? '(pending doctor review) ' : '') + (route.title || ''),
      'Flags':      flags.length ? flags.join('; ') : 'None',
      'Name':       answers.name || '',
      'Email':      answers.email || '',
      'Phone':      answers.phone || ''
    };
    Object.keys(answers).forEach(function (k) {
      if (['name', 'email', 'phone', 'goal'].indexOf(k) < 0) properties[k] = answers[k];
    });

    // The result screen promises they won't fill anything in again, so checkout opens with the
    // quiz email, name and number filled in. That email also makes Shopify record an abandoned checkout.
    // A plain /checkout?checkout[email]= is ignored for first-time visitors, so the cart is made
    // through the Storefront API (email in the body), and only the name rides on the link,
    // which Shopify's redirect strips. Falls back to the old cart add if that call fails.
    var full = (answers.name || '').trim();
    var nameQs = [
      ['checkout[billing_address][first_name]', full.split(' ')[0]],
      ['checkout[billing_address][last_name]', full.split(' ').slice(1).join(' ')],
      // Their number is asked again at checkout; fill it from the quiz (Jandre 2026-09-18).
      ['checkout[billing_address][phone]', normalisePhone(answers.phone)]
    ].filter(function (p) { return p[1]; })
     .map(function (p) { return '&' + encodeURIComponent(p[0]) + '=' + encodeURIComponent(p[1]); }).join('');
    var buyer = { countryCode: 'ZA' };
    if (answers.email) buyer.email = answers.email;

    fetch('/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        query: 'mutation($i:CartInput!){cartCreate(input:$i){cart{checkoutUrl} userErrors{message}}}',
        variables: { i: {
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + PEPTIDE_DOCTOR_CONSULT, quantity: 1,
            attributes: Object.keys(properties).map(function (k) { return { key: k, value: String(properties[k]) }; }) }],
          buyerIdentity: buyer
        } }
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var url = d && d.data && d.data.cartCreate.cart && d.data.cartCreate.cart.checkoutUrl;
        if (!url) throw new Error('no checkoutUrl');
        window.location.href = url + (url.indexOf('?') < 0 ? '?' : '') + nameQs;
      })
      .catch(function () {
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: [{ id: PEPTIDE_DOCTOR_CONSULT, quantity: 1, properties: properties }] })
            });
          })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/checkout'; });
      });
  }

  // ── Boot ──────────────────────────────────────────────────────────────────
  // The details form is the first thing on the page; no scroll on load so the intro stays in view.
  reset();
  if (loadResult()) { showResult(true); if (param('quiz') === 'quiz-finished') metaQuizFinished(); }
  else if (param('quiz') === 'quiz-start' && loadDetails()) { started = true; renderGoal(); }
  else { loadDetails(); renderGate(true); }
  cleanAddress(10000);
})();
